import React, {
  useState,
  useRef,
  useEffect,
} from 'react';
import {
  arrayOf,
  bool,
  string,
  number,
} from 'prop-types';
import { useLocation } from 'react-router-dom';
import classnames from 'classnames';
import Select from '../Select/Select';
import Idea from './Idea/Idea';
import Button from '../Button/Button';
import { formingIdeas, sortingIdeas } from '../../features/DiscussionData/formingData';
import styles from './AllIdea.module.scss';
import Icon from '../Icon/Icon';

const optionsSort = [
  {
    value: 0,
    label: 'СНАЧАЛА ПОПУЛЯРНОЕ',
  },
  {
    value: 1,
    label: 'СНАЧАЛА НОВОЕ',
  },
  {
    value: 2,
    label: 'СНАЧАЛА СТАРОЕ',
  },
];

const AllIdea = ({
  ideas, className, disabled, archive,
}) => {
  const stepNumber = useRef(12);
  const [sortId, setSortId] = useState(0);
  const [sliceArray, setSliceArray] = useState([]);
  const [shareIdea, setShareIdea] = useState();
  const [maxNumber, setMaxNumber] = useState(
    // eslint-disable-next-line max-len
    (stepNumber.current >= ideas.length) && ideas.length > 1 ? ideas.length : stepNumber.current,
  );
  const [maxStepForOneId, setMaxStepForOneId] = useState(1);
  const more = ideas.length > maxNumber;
  const [arIdeas, setArIdeas] = useState([]);

  const slicedIdeas = arIdeas.slice(0, maxNumber);

  const location = useLocation();

  useEffect(() => {
    if (!arIdeas.length) return;

    const searchParams = new URLSearchParams(location.search);
    const shareId = searchParams.get('share');
    if (shareId) {
      setMaxNumber(1);
      setShareIdea(true);
      // eslint-disable-next-line radix
      const shareIndex = arIdeas.findIndex((idea) => idea.id === parseInt(shareId));

      const arrayForSort = [...arIdeas];
      // eslint-disable-next-line max-len
      const arrayWithSort = [arrayForSort[shareIndex]].concat(arrayForSort.slice(0, shareIndex), arrayForSort.slice(shareIndex + 1));
      setSliceArray(arrayWithSort);
    }
  }, [arIdeas]);

  useEffect(() => {
    setArIdeas((prevState) => [...sortingIdeas([...prevState], sortId)], sortId);
  }, [sortId]);

  useEffect(() => {
    setArIdeas(
      formingIdeas([...ideas], sortId),
    );
  }, [ideas]);

  const handleMore = () => {
    setMaxNumber((prev) => prev + stepNumber.current);
    setMaxStepForOneId((prev) => prev + stepNumber.current);
  };

  const arIdeasWithOneIdea = sliceArray.slice(0, maxStepForOneId);

  const switchLikes = (prevIdeaId, newIdeaId, currentUserLike) => setArIdeas(arIdeas.map((idea) => {
    if (prevIdeaId === idea.id || (prevIdeaId === idea.id && prevIdeaId === newIdeaId)) {
      return {
        ...idea,
        currentUserLike: null,
        isLiked: false,
        likesCount: idea.likesCount - 1,
      };
    }

    if (newIdeaId === idea.id && currentUserLike) {
      return {
        ...idea,
        currentUserLike,
        isLiked: true,
        likesCount: idea.likesCount + 1,
      };
    }

    return {
      ...idea,
      currentUserLike: null,
      isLiked: false,
    };
  }));

  const currentlyLikedIdea = arIdeas.length ? arIdeas.find((el) => el.isLiked) : null;
  const currentlyLikedIdeaId = currentlyLikedIdea && currentlyLikedIdea.id;
  const currentLikeId = currentlyLikedIdea && currentlyLikedIdea.currentUserLike;

  const hasNoLikes = arIdeas && arIdeas.every((el) => !el.isLiked);

  return (
    <div className={classnames(
      styles.wrapper,
      className,
    )}
    >
      <div className={styles.container}>
        <div className={styles.topRow}>
          {ideas.length > 1 && !archive && (
          <div className={styles.disclaimer}>
            <Icon name="warning" />
            <p>
              Выбрать можно только одну идею.
            </p>
          </div>
          )}
          {ideas.length > 1 && (
          <div className={`${styles.sorting} select__button`}>
            <Select
              options={optionsSort}
              defaultValue={optionsSort[0]}
              type="button--white"
              className="select--button"
              classIsOpen="select--button--is-open"
              isSearchable={false}
              setSortId={setSortId}
            />
          </div>
          )}
        </div>
        {(shareIdea ? arIdeasWithOneIdea : slicedIdeas).map(({
          id, user, message, likesCount, usersPublic, files, isLiked,
        }) => (
          <Idea
            hasNoLikes={hasNoLikes}
            isLiked={isLiked}
            switchLikes={switchLikes}
            currentlyLikedIdeaId={currentlyLikedIdeaId}
            currentLikeId={currentLikeId}
            ideaId={id}
            key={id}
            user={user}
            text={message}
            likes={likesCount}
            experts={usersPublic}
            disabled={disabled}
            files={files}
          />
        ))}
      </div>
      {more
        ? (
          <div className={styles.buttonWrapper}>
            <Button
              typeButton="button"
              className={styles.more}
              onClick={handleMore}
            >
              загрузить ещё
            </Button>
          </div>
        ) : null}
    </div>
  );
};

AllIdea.propTypes = {
  ideas: arrayOf({
    persone: {
      name: string,
      surname: string,
      href: string,
    },
    num: number,
    text: string,
    likes: number,
    comments: {
      person: {
        name: string,
        surname: string,
        href: string,
      },
      textComment: string,
    },
    end: bool,
  }),
  className: string,
  archive: bool,
  disabled: bool,
};

AllIdea.defaultProps = {
  ideas: [],
  className: '',
  disabled: true,
  archive: false,
};

export default AllIdea;
